import { render } from "./folderItem.vue?vue&type=template&id=45353d86"
import script from "./folderItem.vue?vue&type=script&lang=js"
export * from "./folderItem.vue?vue&type=script&lang=js"

import "./folderItem.vue?vue&type=style&index=0&id=45353d86&lang=scss"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__